import ApiV2 from './api-v2';

/**
 * Triggers semantic clip generation for a given stream via eos-app.
 * eos-app proxies to the transcript-to-clip-gen /semantic endpoint (same as media-recording-ended.ts).
 * Uses REACT_APP_EOS_API_2 as the base URL so CORS and auth are handled by eos-app.
 */
export async function regenerateSemanticClips(streamId: string): Promise<void> {
  await ApiV2.post<unknown>(`/api/streams/${encodeURIComponent(streamId)}/semantic`, {
    fragmentType: 'topic',
    type: 'topic',
  });
}
